import useFetch from "./useFetch";

const useGetResponse = (key) =>
  useFetch(key, `${process.env.REACT_APP_API_BASE_URL}/api/${key}`);

export default useGetResponse;
